module.exports = __webpack_public_path__ + "featpic.82a5a17fb5.webp";